export enum Countries {
    BRAZIL = "BR",
    COLOMBIA = "CO",
    ECUADOR = "EC",
    GUATEMALA = "GT",
    MEXICO = "MX",
    PANAMA = "PA",
    PERU = "PE",
    PHILIPPINES = "PH",
    SOUTH_AFRICA = "ZA",
}
